import { createContext } from "react";

const ChartContext = createContext()

export default ChartContext;